import shakeChoco from '@/ui/assets/images/shake-choco.png';
import shakeFresa from '@/ui/assets/images/shake-fresa.png';
import headersBackground from '@/ui/assets/images/headers/FondoHeaders.png';
import logoDulceComoVos from '@/ui/assets/images/logo-dulce-como-vos.png';

export const Images = {
    shakeChoco,
    shakeFresa,
    headersBackground,
    logoDulceComoVos
}